module.exports = __webpack_public_path__ + "img/934512472.4729118c.jpg";